<template>
  <span>
    <span
      v-if="order.oracleId"
      class="tag is-success cursor-pointer"
      title="La commande a été envoyée à Oracle avec succès et ne peut plus être modifiée dans ISF !"
    >
      Commande envoyée à Oracle
    </span>
    <span
      v-else-if="order.oracleStatus == 'ERROR'"
      class="tag is-danger"
    >
      Erreur lors de l'envoi de la commande à Oracle
    </span>
    <span
      v-else-if="
        order.oracleStatus == 'CREATED' ||
        order.oracleStatus == 'PROCESSING'
      "
      class="tag is-warning"
    >
      En cours d'envoi à Oracle
    </span>
    <span
      v-else
      class="tag is-info cursor-pointer"
      title="La commande n'a pas été envoyée à Oracle et sera envoyée automatiquement lors de la validation de la commande par le sous-traitant !"
    >
      Commande non présente dans Oracle
    </span>
  </span>
</template>

<script>
export default {
  name: 'oracle-status-display',
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
};
</script>